import React from "react";
import { connect } from "react-redux";
import BVATool from "../../pages/BVATool";
import SignInContainer from "../SignInContainer";

const ToolContainer = (props) => {
  if (props.user) {
    return <BVATool user={props.user} taxes={props.taxes} />;
  } else {
    return <SignInContainer />;
  }
};

const mapStateToProps = (state) => ({
  user: state.user,
  taxes: state.taxes,
});

export default connect(mapStateToProps)(ToolContainer);
